import { SwitchField } from "common";
import React, { useMemo } from "react";
import { ValidationLevel } from "types";
import { useCreatePurchaseStore } from "../../stores/createPurchaseStore";

export const ArrivalRestrictions = React.memo(() => {
    const product = useCreatePurchaseStore((state) => state.getActiveProduct().id);
    const isVariableDemographicsPackage = useCreatePurchaseStore((state) => state.isVariableDemographicsPackage());

    const packagePurchase = useCreatePurchaseStore((state) => !!state.getFirstItem().parentProduct?.id);
    const isFirstItem = useCreatePurchaseStore((state) => state.getFirstItem().product.id === product);
    const arrivalErrors = useCreatePurchaseStore((state) => state.errors);

    const errors = useMemo(() => {
        return arrivalErrors?.filter((error) => error.field === "arrivalDateTime") ?? [];
    }, [arrivalErrors]);

    const hasErrors = errors.length > 0;

    const shouldIgnoreRestrictions = useCreatePurchaseStore((state) => state.shouldIgnoreRestrictions);

    const handleIgnoreRestriction = (isChecked: boolean) => {
        useCreatePurchaseStore.setState({ shouldIgnoreRestrictions: isChecked });
    };

    const hasPackageErrors = hasErrors && packagePurchase && (isFirstItem || isVariableDemographicsPackage);
    const hasValidationErrors = errors.some((error) => error.level === ValidationLevel.ERROR);

    return (
        <div className="flex w-full justify-between">
            <div className="space-y-0.5">
                {errors.length > 0 &&
                    errors.map((error) => (
                        <div key={error.code}>
                            <span className="text-danger">{error.message}</span>
                        </div>
                    ))}
            </div>
            {hasPackageErrors && !hasValidationErrors && (
                <div className="self-end">
                    <SwitchField size="small" isChecked={shouldIgnoreRestrictions} onChange={handleIgnoreRestriction}>
                        Ignore Restrictions
                    </SwitchField>
                </div>
            )}
        </div>
    );
});

ArrivalRestrictions.displayName = "ArrivalRestrictions";
